export default '/build/f05d675e.svg'